import { ChatOllama } from "@langchain/community/chat_models/ollama";
import { ChatTogetherAI } from "@langchain/community/chat_models/togetherai";
import { ChatGroq } from "@langchain/groq";

const responseSchema = {
  type: "object",
  properties: {
    message: {
      type: "string",
    },
  },
  required: ["message"],
};

const getAPIKey = () => {
  const Env = process.env;
  // API key will be list of string separated by comma
  // get random key from the list
  const keys = Env?.LLM_API_KEY?.split(",");
  return keys?.[0];
};

export const getLLMModel = (format?: string) => {
  const Env = process.env;
  if (Env.LLM_TYPE === "ollama") {
    const details: any = {
      baseUrl: "http://localhost:11434",
      model: Env.LLM_MODEL,
      // format: "json",
    };
    if (format) {
      details.format = format;
    }
    return new ChatOllama(details);
  } else if (Env.LLM_TYPE === "groq") {
    // @ts-ignore
    return new ChatGroq({
      apiKey: getAPIKey(),
      modelName: Env.LLM_MODEL,
      // verbose: true,
    }).bind({
      // if format is json then response will be in json format
      ...(format === "json"
        ? {
            response_format: {
              type: "json_object", // Define the response format as a JSON object
              // schema: responseSchema, // Pass in the schema for the model's response
            },
          }
        : {}),
    });
  } else if (Env.LLM_TYPE === "togetherai") {
    return new ChatTogetherAI({
      togetherAIApiKey: Env.LLM_API_KEY,
      modelName: Env.LLM_MODEL,
    }).bind({
      response_format: {
        type: "json_object", // Define the response format as a JSON object
        schema: responseSchema, // Pass in the schema for the model's response
      },
    });
  }
  throw new Error("LLM not found in configuration");
};
